export default __webpack_public_path__ + "static/O0231-ce72792221bd7c849ca1eaecb42c38c2.png";